import React from "react";
import Reports from "./Reports";

const EnquiryReport = () => <Reports reportType="enquiry" />;

export default EnquiryReport;
